module.exports = {"450603001":"水营街道","450603002":"珠河街道","450603003":"文昌街道","450603101":"大菉镇","450603102":"华石镇","450603103":"那梭镇","450603104":"那良镇","450603105":"峒中镇","450603106":"江山镇","450603107":"茅岭镇","450603108":"扶隆镇","450603203":"滩营乡","450603209":"十万山瑶族乡","450603450":"小峰经济作物场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450603.json
// module id = 2249
// module chunks = 0